import React from 'react'
import _ from 'lodash'
import classnames from 'classnames'

import * as PricingConstants from './../helpers/constant'

import SubscriptionSVG from './../../../images/svg/subscription.svg'

const CreditSlabs = ({
  slabs,
  selectedSlab,
  currency = 'USD',
  onClickSlabSelect
}) => {

  if (_.isEmpty(slabs))
    return null

  return (
    <div className="credit-slabs">
      <div className="subscription-plans-container">
        {slabs.map((plan, index) => {
          return (
            <div
              className={classnames("subscription-plan", {
                "selected-plan": selectedSlab && selectedSlab.data.min === plan.data.min
              })}
              key={index}
              onClick={() => onClickSlabSelect(plan)}
            >
              <SubscriptionSVG className="subscription-svg" />
              <div>
                <div className="plan-price">
                  <div>{plan.label}</div>
                </div>
                <div className="plan-desc">
                  <span className="plan-name-price notranslate">
                    {PricingConstants.CURRENCY[currency].symbol}
                    {Number(plan.data.unit_price * plan.value).toLocaleString(PricingConstants.CURRENCY.USD.locale)}
                  </span>
                  <span className="plan-type"> {"onwards"}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  )
}

export default CreditSlabs